import { Unauthorized } from "@app/shared/ErrorPages";
import { Roles, UserContext } from "@app/user";
import { JSX, useContext } from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import BulkTargetingWizard from "./TargetingWizard";
import ViewMyTargets from "./ViewMyTargets";

const TargetingRouter = (props: RouteComponentProps): JSX.Element => {
  const userContext = useContext(UserContext);
  if (!userContext.roles.includes(Roles.VOLUME_TARGET)) {
    return <Unauthorized />;
  }
  return (
    <Switch>
      <Route path={`${props.match.path}/view`} component={ViewMyTargets} />
      <Redirect from={props.match.path} to={`${props.match.path}/view`} exact={true} />
      <Route path={`${props.match.path}/import`} component={BulkTargetingWizard} />
    </Switch>
  );
};

export default TargetingRouter;
